// extracted by mini-css-extract-plugin
export default {"application-form-container":"applicationForm_application-form-container__WGbSI","form":"applicationForm_form__6-7yt"};